import store from '@/store/index.js';

export const StripeMixin = {
  data() {
    return {
      countryIso: null,
    };
  },
  methods: {
    goToPersonalInfos() {
      this.showSepaNotification = false;
      this.$router.push({name: 'personal-infos'});
    },
    checkPersonalInfo(profileData) {
      return (
        profileData &&
        (profileData?.profile?.firstName?.trim().length || 0) > 1 &&
        (profileData?.profile?.lastName?.trim().length || 0) > 1
      );
    },
    async loadStripeScript() {
      if (!document.getElementById('script-stripe')) {
        var script = document.createElement('script');
        script.id = 'script-stripe';
        script.src = 'https://js.stripe.com/v3/';
        script.type = 'text/javascript';
        document.head.appendChild(script);
      }
      return new Promise((resolve) => setTimeout(resolve, 400));
    },
    calcCountryIso() {
      const CountryFromCompany =
        this.selectedCompanyAllData?.admin_information?.legal_address?.country;
      const CountryFromBilling = this.basicBilling?.invoicingAddressCountry;
      let countryIso = this.countriesList.find(
        (c) => c.id === CountryFromBilling || c.id === CountryFromCompany,
      );
      if (countryIso) {
        this.countryIso = countryIso.isoAlpha2Code || null;
      }
    },
    validateCountryIso(iban) {
      if (!this.countryIso) {
        const countryFromIban = iban.substring(0, 2).replace(/[^A-Za-z]/g, '');
        if (!countryFromIban || countryFromIban.length !== 2) {
          this.actionAddNotification({
            msg: `Erreur lors de la confirmation de votre IBAN. Vérifiez vos détails de facturation`,
            color: 'red',
            disappearing: true,
            once: true,
          });
          return false;
        } else {
          this.countryIso = countryFromIban;
        }
      }
      return true;
    },
    async stripeConfirmSepaDebitSetup(params) {
      const stripe = Stripe(params.stripePublicKey);
      return await stripe.confirmSepaDebitSetup(params.secret, {
        payment_method: {
          //sepa_debit: { iban: "FR1420041010050500013M02606" },
          sepa_debit: {iban: params.iban},
          billing_details: {
            name: params.name,
            email: params.email,
            address: params.address,
          },
        },
        mandate_data: {
          customer_acceptance: {
            type: 'online',
            accepted_at: new Date().getTime(),
            online: {
              ip_address: params.clientIp,
              user_agent: navigator.userAgent || '',
            },
          },
        },
      });
    },
  },
};

export default {StripeMixin};
